import axios from 'axios';

export interface ICanLinkAccounts {
  current: string;
  target: string;
}

export const canLinkAccounts = async ({ current, target }: ICanLinkAccounts) =>
  axios.get('user/link', { params: { current, target } });
